export class UpdateProductWarrantyService{
   ProductId : string;
   WarrantyIds : string;                                                                                                
}

export class UpdateProductWarrantyServiceResponseModel{
   productId : string;
   warrantyIds : string;
}
export class UpdateWarrantyServiceModel{
   ProductId :number;
   WarrantyIds :string;   
   IsActive : string;                                                                                       
}

export class UpdateWarrantyServiceResponseModel{
   productId :string;
   warrantyIds :string; 
   isActive : string;                                                                                          
}


